<mat-card class="cardWithShadow theme-card">

  <mat-card-content class="b-t-1">
    <form class="m-t-30 change-pass" [formGroup]="newPasswordForm" (ngSubmit)="changePassword(newPasswordForm.value)">
      <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Old Password</mat-label>
      <mat-form-field appearance="outline" class="w-100" color="primary">
        <input matInput [type]="!showVarPassword ? 'password': 'text'" formControlName="oldPassword" />
        <img alt="eye closed" class="password-eye"
        src="{{ !showVarPassword ? 'assets/images/svgs/eye_open_grey.svg' : 'assets/images/svgs/eye_closed.svg'}}"
        (click)="showVarPassword = !showVarPassword" />
        @if(newPass['oldPassword'].touched && newPass['oldPassword'].invalid) {
        <mat-hint class="m-b-16 error-msg">
          @if(newPass['oldPassword'].errors &&
          newPass['oldPassword'].errors['required']) {
          <div class="text-error">Old Password is required.</div>
          }
        </mat-hint>
        }
      </mat-form-field>

      <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">New Password</mat-label>
      <mat-form-field appearance="outline" class="w-100" color="primary">
        <input matInput [type]="!newVarPassword ? 'password': 'text'" formControlName="password" (paste)="$event.preventDefault();" oncopy="return false"/>
        <img alt="eye closed" class="password-eye"
        src="{{ !newVarPassword ? 'assets/images/svgs/eye_open_grey.svg' : 'assets/images/svgs/eye_closed.svg'}}"
        (click)="newVarPassword = !newVarPassword" />
        @if(newPass['password'].touched && newPass['password'].invalid) {
        <mat-hint class="m-b-16 error-msg">
          @if(newPass['password'].errors &&
          newPass['password'].errors['required']) {
          <div class="text-error">New Password is required.</div>
          }
        </mat-hint>
        }
        <mat-hint class="password-hint">8-20 characters, 1 Upper case, 1 Lower case, 1 Special character</mat-hint>
      </mat-form-field>

      <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block m-t-20">Confirm Password</mat-label>
      <mat-form-field appearance="outline" class="w-100" color="primary">
        <input matInput type="password" formControlName="confirmPassword" (paste)="$event.preventDefault();" oncopy="return false"/>
        @if(newPass['confirmPassword'].touched && newPass['confirmPassword'].invalid) {
        <mat-hint class="m-b-16 error-msg">
          @if(newPass['confirmPassword'].errors &&
          newPass['confirmPassword'].errors['required']) {
          <div class="text-error">Confirm Password is required.</div>
          }
          @if(newPass['confirmPassword'].hasError('NoPassswordMatch')){
            <div class="text-error">New Password and Confirm Password are not matching.</div>
          }
        </mat-hint>
        }
        
      </mat-form-field>
      <div class="action-btn">
        <button mat-flat-button color="default" (click)="newPasswordForm.reset()" class="w-40">Reset</button>
        <button mat-flat-button color="primary" class="w-40" [disabled]="!newPasswordForm.valid">
          Submit
        </button>
      </div>
      
      <!-- input -->
    </form>
  </mat-card-content>
</mat-card>